import React from "react";
import Index from "./pages/index";
function App() {
  return <Index />;
}

export default App;
